// The /totem kiosk page is not part of the public navigation. It is reachable
// only when explicitly enabled via the `?totem=1` query string — e.g. on the
// touch monitor used at fairs. Every load must carry the parameter; there is no
// persistence and no automatic date-based opening.
export const TOTEM_ACCESS_PARAM = "totem";

const TRUTHY_VALUES = new Set(["1", "true", "on", "yes"]);

export const isTotemAccessEnabled = (search = "") => {
  try {
    const params = new URLSearchParams(search);
    if (!params.has(TOTEM_ACCESS_PARAM)) {
      return false;
    }

    const value = (params.get(TOTEM_ACCESS_PARAM) || "").trim().toLowerCase();
    // A bare `?totem` (no value) or any recognised truthy value enables the
    // page; an explicit `?totem=0` / `?totem=false` keeps it hidden.
    return value === "" || TRUTHY_VALUES.has(value);
  } catch {
    return false;
  }
};
